import { createFileRoute } from '@tanstack/react-router'
import { Healthcheck } from 'pages/healthCheck/Healthcheck'

export const Route = createFileRoute('/health-check')({
  component: Healthcheck,
})
